import { convertRowsToData } from '../utils/dataUtils'
export default function DonutProgressChartDataController(rows, config, hiddenItems) {
  let headers = rows[0]
  const propperHeaders = ['id', ...headers.slice(1)]
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)
  if (hiddenItems) data = data.filter(d => hiddenItems.indexOf(d.id) < 0)

  let keyDict = {}
  keyDict[propperHeaders[1]] = 'value'
  keyDict[propperHeaders[2]] = 'total'
  
  
  data = data.map(d => ({
    id: d.id,
    ...d.value.reduce((accumulator, current) => {
      accumulator[keyDict[current.id]] = current.value
      return accumulator
    }, {}),
  }))
  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let diff = a.value - b.value
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }

  data = data.map(d => {
    let percent = (100 * d.value) / d.total
    //if (percent < 1) percent = '<1'
    return { ...d, percent: percent }
  })

  return data
  // return data.map((d,i)=>{
  //   if(!d.id) d.id = i
  //   return d
  // })
}
